import { endOfDay, startOfDay } from 'date-fns';
import React from 'react';
import styled from 'styled-components';
import { DatePickerField } from './DatePickerField';

const Container = styled.div<{ $displayOnSingleLine?: boolean }>`
  display: ${({ $displayOnSingleLine }) =>
    $displayOnSingleLine ? 'flex' : 'block'};
`;

const StyledDatePickerField = styled(DatePickerField)`
  margin-right: 2rem;
`;

type DateRangePickerFieldProps = {
  displayOnSingleLine?: boolean;
  fromName?: string;
  toName?: string;
  forceShowErrors?: boolean;
};

export function DateRangePickerField({
  displayOnSingleLine,
  fromName = 'from',
  toName = 'to',
  forceShowErrors,
}: DateRangePickerFieldProps) {
  return (
    <Container $displayOnSingleLine={displayOnSingleLine}>
      <StyledDatePickerField
        label="From"
        name={fromName}
        formatDate={startOfDay}
        forceShowErrors={forceShowErrors}
      />
      <StyledDatePickerField
        label="To"
        name={toName}
        formatDate={endOfDay}
        forceShowErrors={forceShowErrors}
      />
    </Container>
  );
}
